<template>
  <div style="display: flex;align-items: center;height:48px">

    <el-dropdown @command="updateURLLocale">
      <span>
        {{ languages[this.$i18n.locale] }}<i class="el-icon-arrow-down el-icon--right" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(value, key) in languages" :key="`Lang${key}`" :command="key">{{ value }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>

export default {
  // data.languages have to add here after added lang.json
  data() {
    return {
      languages: {
        en: 'English',
        cn: '中文'
      }
    }
  },
  methods: {
    updateURLLocale(command) {
      this.$i18n.locale = command
      this.$store.dispatch('languageStore/setLanguage', command)
    }
  }
}
</script>

<style scoped>
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;

  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
